var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mapRoot"}},[_c('div',{attrs:{"id":"container"}}),_c('div',{attrs:{"id":"navIcon"},on:{"click":_vm.handleMapNav}},[_c('img',{attrs:{"src":require("../../assets/img/nav.png"),"alt":"导航"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }